var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 46,
    viewBox: "0 0 97 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.7617,
    y: 20.0933,
    width: 17.3832,
    height: 2.58427,
    rx: 1.29213,
    transform: "rotate(-180 87.7617 20.0933)",
    fill: "#F62D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4661 21.6448H71.9553C71.0825 21.6448 70.375 22.3523 70.375 23.2251V25.4667C70.375 27.0668 71.6721 28.3639 73.2722 28.3639H86.4661C87.1798 28.3639 87.7583 27.7854 87.7583 27.0717C87.7583 26.3581 87.1798 25.7796 86.4661 25.7796H73.9254C73.6198 25.7796 73.3721 25.5319 73.3721 25.2263V24.229H86.4661C87.1798 24.229 87.7583 23.6505 87.7583 22.9369C87.7583 22.2233 87.1798 21.6448 86.4661 21.6448Z",
    fill: "#F62D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23828 18.8014C9.23828 18.0878 9.81679 17.5093 10.5304 17.5093H28.0267C28.7403 17.5093 29.3188 18.0878 29.3188 18.8014C29.3188 19.515 28.7403 20.0935 28.0267 20.0935H20.9269V26.9732C20.9269 27.8836 20.1889 28.6216 19.2785 28.6216C18.3682 28.6216 17.6301 27.8836 17.6301 26.9732V20.0935H10.5304C9.81679 20.0935 9.23828 19.515 9.23828 18.8014Z",
    fill: "#F62D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1229 28.1898C28.3133 27.8202 28.0736 26.7839 28.6388 26.0964L34.8232 18.5736C35.5122 17.7356 36.54 17.25 37.6249 17.25C38.721 17.25 39.7583 17.7457 40.4468 18.5985L46.4966 26.0912C47.0557 26.7837 46.8119 27.8177 46.0021 28.1873C45.4418 28.4431 44.7795 28.2912 44.3866 27.8169L37.7888 19.8522C37.6699 19.7087 37.4497 19.7087 37.3308 19.8522L30.7292 27.8215C30.3385 28.2931 29.68 28.4441 29.1229 28.1898Z",
    fill: "#F62D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4004 19.1568C49.4004 18.2464 50.1384 17.5084 51.0488 17.5084C51.9592 17.5084 52.6972 18.2464 52.6972 19.1568V21.6433H58.3917L65.7168 17.7387C66.2463 17.4565 66.9021 17.5973 67.2691 18.0719C67.7255 18.6622 67.5558 19.5196 66.9089 19.8914L61.7457 22.8594C61.5874 22.9504 61.5874 23.1788 61.7457 23.2698L66.8236 26.1888C67.4955 26.575 67.6376 27.4838 67.1155 28.0567C66.7435 28.465 66.1426 28.5702 65.654 28.3128L58.3917 24.486H52.6972V26.9724C52.6972 27.8828 51.9592 28.6208 51.0488 28.6208C50.1384 28.6208 49.4004 27.8828 49.4004 26.9724V19.1568Z",
    fill: "#F62D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTake);
export default __webpack_public_path__ + "static/media/Take.fc17a907429e9587b537cc5561439320.svg";
export { ForwardRef as ReactComponent };